import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const SliderMask = styled.div<React.CSSProperties>`
  background: linear-gradient(
    0deg,
    #0f0f0f 40.55%,
    #0f0f0f 58.67%,
    rgba(15, 15, 15, 0) 89.25%
  );
  height: ${320 * Screen.widthRatio}px;
  position: absolute;
  width: ${1920 * Screen.widthRatio}px;
  z-index: 1;
  top: ${431 * Screen.widthRatio}px;
`;

export default SliderMask;
